import { OAuthService } from 'angular-oauth2-oidc';
import { client } from './kspl-franco/client.gen';

/**
 * Configure the OpenAPI client with OAuth token interceptor
 */
export function configureApiClient(oauthService: OAuthService): void {
  // Add request interceptor to include OAuth token
  client.interceptors.request.use((request, options) => {
    const token = oauthService.getAccessToken();

    if (token) {
      request.headers.set('Authorization', `Bearer ${token}`);
      console.debug('API Client: Added token to request:', request.url);
    } else {
      console.debug('API Client: No token available for request:', request.url);
    }

    return request;
  });

  console.debug('API Client: Configured with OAuth interceptor');
}
